import store from '../../store'

export default (to, from, next) => {
  console.log('role', to)
  // If the path role is NOT equal to the current user role
  if (to.matched.some(m => 'role' in m.meta && store.state.auth.role !== m.meta.role)) {
    if (store.state.auth.logged) {
      // If is logged in go to not authorized path
      return next({name: 'notAuthorized'})
    } else {
      // Otherwise go to login path
      return next({name: 'login'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/middleware/role.js